export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Signup.vue?vue&type=template&id=645e65ee"


//////////////////
// WEBPACK FOOTER
// ./src/components/auth/signup/Signup.vue?vue&type=template&id=645e65ee
// module id = 8SYZ
// module chunks = 41